import { render, staticRenderFns } from "./SmartWorksSales.vue?vue&type=template&id=618bd212&scoped=true&"
import script from "./SmartWorksSales.vue?vue&type=script&lang=js&"
export * from "./SmartWorksSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618bd212",
  null
  
)

export default component.exports